(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenvy-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zenvy-homepage')){customElements.define('zenvy-homepage',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const root=this;const data=JSON.parse(root.querySelector('[data-zenvy-config]').textContent);const SITE_CONFIG=data.settings;SITE_CONFIG.brandZh=SITE_CONFIG.brand;const translations=data.translations;
const textNodes=[...root.querySelectorAll('[data-i18n]')];
    const htmlNodes=[...root.querySelectorAll('[data-i18n-html]')];
    const en=translations.en;const zh=translations.zh;
    let language='en';
    const menu=root.querySelector('.menu-toggle');const nav=root.querySelector('.nav');
    function setMenu(open){nav.classList.toggle('open',open);menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',translations[language][open?'closeMenu':'openMenu']);}
    function applyContact(){
      root.querySelectorAll('[data-brand]').forEach(el=>el.textContent=language==='zh'?SITE_CONFIG.brandZh:SITE_CONFIG.brand);
      [['emailValue',SITE_CONFIG.email,'mailto:'],['whatsappValue',SITE_CONFIG.whatsapp,'https://wa.me/']].forEach(([id,value,prefix])=>{if(!value)return;const el=root.querySelector('#'+id);const link=document.createElement('a');link.className='contact-value';link.textContent=value;link.href=prefix+(prefix.startsWith('https')?value.replace(/\D/g,''):value);el.replaceChildren(link);el.className='';});
    }
    function setLanguage(value){language=value;const dict=language==='zh'?zh:en;textNodes.forEach(el=>el.textContent=dict[el.dataset.i18n]);htmlNodes.forEach(el=>el.innerHTML=dict[el.dataset.i18nHtml]);document.documentElement.lang=language==='zh'?'zh-CN':'en';root.classList.toggle('lang-zh',language==='zh');document.title=SITE_CONFIG.brand+' — '+dict.title;root.querySelector('#langToggle').setAttribute('aria-label',dict[language==='zh'?'switchEnglish':'switchChinese']);root.querySelectorAll('[data-i18n-aria]').forEach(el=>el.setAttribute('aria-label',dict[el.dataset.i18nAria]));setMenu(false);applyContact();try{localStorage.setItem('zenvy-language',language)}catch(e){}}
    root.querySelector('#langToggle').addEventListener('click',()=>setLanguage(language==='en'?'zh':'en'));
    menu.addEventListener('click',()=>setMenu(menu.getAttribute('aria-expanded')!=='true'));
    nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMenu(false)));
    root.addEventListener('keydown',e=>{if(e.key==='Escape'&&nav.classList.contains('open')){setMenu(false);menu.focus();}});
    root.querySelector('#year').textContent=new Date().getFullYear();
    let initial=document.documentElement.lang.startsWith('zh')?'zh':'en';try{const saved=localStorage.getItem('zenvy-language');if(saved==='zh'||saved==='en')initial=saved}catch(e){}setLanguage(initial);
  
}});}

  } catch(e) { console.error(e); }
})();
})();
